import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedules-assignment',
  templateUrl: './schedules-assignment.component.html',
  styleUrls: ['./schedules-assignment.component.scss'],
  standalone: false,
})
export class SchedulesAssignmentComponent implements OnInit {
  approvals: any[] = [];

  options = {
    deviceFilter: [
      'PMG | 10.000 Devices / 7.500 Locations',
      'Total | 1.200 Devices / 1.100 Locations',
      'Orlen | 1.200 Devices / 1.100 Locations',
      'Shell | 1.200 Devices / 1.100 Locations',
      'Aral | 1.200 Devices / 1.100 Locations',
    ],
    schedule: ['PMG 100%', 'Total content share 70% / 30%', 'Orlen content share 70% / 30%', 'Aral content share 50% / 50%'],
  };

  ngOnInit() {
    this.approvals.push({
      deviceFilter: 'PMG | 10.000 Devices / 7.500 Locations',
      schedule: 'PMG 100%',
    });

    this.approvals.push({
      deviceFilter: 'Total | 1.200 Devices / 1.100 Locations',
      schedule: 'Total content share 70% / 30%',
    });

    this.approvals.push({
      deviceFilter: 'Orlen | 1.200 Devices / 1.100 Locations',
      schedule: 'Orlen content share 70% / 30%',
    });

    this.approvals.push({
      deviceFilter: 'Aral | 1.200 Devices / 1.100 Locations',
      schedule: 'Aral content share 50% / 50%',
    });
  }
}
